import { css } from 'styled-components';

import { autographTokens } from '../../tokens/components/Autograph/tokens';
import { controllerTokens } from '../../tokens/components/Controller/tokens';

const shadowWidth = controllerTokens.ContainerShadowWidthBaseKeyboardFocus;
const shadowColor = controllerTokens.ContainerShadowColorBaseKeyboardFocus;
const shadowWidthInvalid = controllerTokens.ContainerShadowWidthInvalidKeyboardFocus;
const shadowColorInvalid = controllerTokens.ContainerShadowColorInvalidKeyboardFocus;

export const autographCore = css`
  position: relative;
`;

export const autographArrow = css`
  background-color: ${autographTokens.ArrowBackgroundColorBaseDefault};
  color: ${autographTokens.ArrowFontColorBaseDefault};
  font-size: ${autographTokens.ArrowFontSizeBaseDefault};
  font-weight: ${autographTokens.ArrowFontWeightBaseDefault};
  line-height: ${autographTokens.ArrowFontLeadingBaseDefault};
  margin-right: 17px;
  padding: 7px;
  padding-left: 14px;
  position: absolute;
  right: 100%;
  white-space: nowrap;

  &::after {
    content: '';
    border-color: transparent;
    border-left-color: ${autographTokens.ArrowBackgroundColorBaseDefault};
    border-right-width: 0;
    border-style: solid;
    border-width: 17px;
    height: 0;
    left: 100%;
    position: absolute;
    top: 0;
    width: 0;
  }
`;

export const autographInput = css`
  background-image: linear-gradient(
      transparent 80%,
      ${autographTokens.InputBorderBottomColorBaseDefault} 80%,
      ${autographTokens.InputBorderBottomColorBaseDefault} 100%
    ),
    linear-gradient(
      transparent 80%,
      ${autographTokens.InputBorderBottomColorBaseDefault} 80%,
      ${autographTokens.InputBorderBottomColorBaseDefault} 100%
    );
  background-position: 0 0, 100% 0;
  background-repeat: no-repeat;
  background-size: 1px 100%;
  border-bottom-color: ${autographTokens.InputBorderBottomColorBaseDefault};
  border-bottom-style: solid;
  border-radius: 0;
  border-width: 0 0 1px;
  color: ${autographTokens.InputFontColorBaseDefault};
  display: block;
  font-family: ${autographTokens.InputFontFamilyBaseDefault};
  font-size: ${autographTokens.InputFontSizeBaseDefault};
  padding: 2px;
  text-indent: 6px;
  transition: background 80ms ease-out, border 80ms ease-out;
  width: 100%;

  &:focus {
    background-color: ${autographTokens.InputBackgroundColorBaseKeyboardFocus};
    background-image: linear-gradient(
        transparent 80%,
        ${autographTokens.InputBorderBottomColorBaseKeyboardFocus} 80%,
        ${autographTokens.InputBorderBottomColorBaseKeyboardFocus} 100%
      ),
      linear-gradient(
        transparent 80%,
        ${autographTokens.InputBorderBottomColorBaseKeyboardFocus} 80%,
        ${autographTokens.InputBorderBottomColorBaseKeyboardFocus} 100%
      );
    border-bottom-color: ${autographTokens.InputBorderBottomColorBaseKeyboardFocus};
    box-shadow:
      /* Bottom       */ 0 ${shadowWidth} 0 0 ${shadowColor},
      /* Right (mask) */ ${shadowWidth} -8px 0 0 #fff,
      /* Right        */ ${shadowWidth} ${shadowWidth} 0 0 ${shadowColor},
      /* Left (mask)  */ -${shadowWidth} -8px 0 0 #fff,
      /* Left         */ -${shadowWidth} ${shadowWidth} 0 0 ${shadowColor};
    outline: none;
  }
`;

export const autographInputError = css`
  background-image: linear-gradient(
      transparent 80%,
      ${autographTokens.InputBorderBottomColorInvalidDefault} 80%,
      ${autographTokens.InputBorderBottomColorInvalidDefault} 100%
    ),
    linear-gradient(
      transparent 80%,
      ${autographTokens.InputBorderBottomColorInvalidDefault} 80%,
      ${autographTokens.InputBorderBottomColorInvalidDefault} 100%
    );
  border-bottom-color: ${autographTokens.InputBorderBottomColorInvalidDefault};

  // Custom focus visuals for the invalid state
  &:focus {
    background-image: linear-gradient(
        transparent 80%,
        ${autographTokens.InputBorderBottomColorInvalidDefault} 80%,
        ${autographTokens.InputBorderBottomColorInvalidDefault} 100%
      ),
      linear-gradient(
        transparent 80%,
        ${autographTokens.InputBorderBottomColorInvalidDefault} 80%,
        ${autographTokens.InputBorderBottomColorInvalidDefault} 100%
      );
    border-bottom-color: ${autographTokens.InputBorderBottomColorInvalidDefault};
    box-shadow:
      /* Bottom       */ 0 ${shadowWidthInvalid} 0 0 ${shadowColorInvalid},
      /* Right (mask) */ ${shadowWidthInvalid} -8px 0 0 #fff,
      /* Right        */ ${shadowWidthInvalid} ${shadowWidthInvalid} 0 0 ${shadowColorInvalid},
      /* Left (mask)  */ -${shadowWidthInvalid} -8px 0 0 #fff,
      /* Left         */ -${shadowWidthInvalid} ${shadowWidthInvalid} 0 0 ${shadowColorInvalid};
    outline: none;
  }
`;

export const helpMessage = css`
  margin-top: ${autographTokens.HelpMarginTopBaseDefault};
`;

export const errorMessage = css`
  margin-top: ${autographTokens.HelpMarginTopBaseDefault};
`;
